import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import PageHero from "@/components/PageHero";
import { Container } from "@/components/shared";

export default function Journal() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data));
  }, []);

  return (
    <div>
      <PageHero
        kicker="The journal"
        title="Dispatches from the crossing"
        intro="Short pieces on the history, the makers, and the meaning of two towns sharing one name. Written plainly, in British English, by an independent hand."
      />

      <section className="py-16 sm:py-24">
        <Container>
          <div className="max-w-4xl mx-auto divide-y divide-[#D6D3CB]">
            {articles.map((a) => (
              <Link key={a.id} to={`/journal/${a.slug}`} data-testid={`journal-item-${a.slug}`} className="group grid sm:grid-cols-12 gap-4 py-10 first:pt-0">
                <div className="sm:col-span-3">
                  <p className="font-playfair italic text-sm text-[#CDA434]">
                    {new Date(a.published_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
                  </p>
                </div>
                <div className="sm:col-span-9">
                  <h2 className="font-serif text-2xl text-[#1E1E2F] group-hover:text-[#003366] transition-colors leading-snug">{a.title}</h2>
                  <p className="font-sans text-base text-[#505A68] leading-relaxed mt-3">{a.deck}</p>
                  <span className="mt-4 inline-flex items-center gap-1 font-sans text-sm font-semibold text-[#003366]">Read the piece <ArrowUpRight size={15} /></span>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
